import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { useCustomerItem } from '../../../../hooks';
import { CustomerItemDataProps } from '../../../../utils/types';
import { SkeletonItem } from '../SkeletonItem';

import { DesktopItemTable } from './desktop';
import { MobileItemTable } from './mobile';
import { TabletItemTable } from './tablet';

export interface ResponsiveItemCustomerProps {
  item: CustomerItemDataProps;
  isSelected: boolean;
  addCustomerToCart: () => void;
  errorTags?: Error;
  isLoadingTags: boolean;
  refresherTags: () => void;
}

export interface ItemTableProps {
  item: CustomerItemDataProps;
  errorTags?: Error;
  isLoadingTags: boolean;
  refresherTags: () => void;
}

export const ItemTable: React.FC<ItemTableProps> = ({
  item,
  errorTags,
  isLoadingTags,
  refresherTags,
}) => {
  const { customerItemIsSelected, handleAddCustomerToCart, customerTagList, isLoadingAction } =
    useCustomerItem({
      customerItem: item,
    });

  const itemData = {
    ...item,
    tags: customerTagList,
  };

  const props = {
    isSelected: customerItemIsSelected,
    addCustomerToCart: handleAddCustomerToCart,
    errorTags,
    isLoadingTags,
    refresherTags,
    item: itemData as unknown as CustomerItemDataProps,
  };

  const responsiveItemTable = useBreakpointValue({
    base: <MobileItemTable {...props} />,
    sm: <TabletItemTable {...props} />,
    lg: <DesktopItemTable {...props} />,
  });

  if (isLoadingAction) {
    return <SkeletonItem pb={0} />;
  }

  return responsiveItemTable;
};
